// Product-page composition, split out of src/product.jsx so the build-time
// prerender can import the tree without pulling in posthog-js and the LinkedIn
// tag. The entry keeps the analytics imports and the mount. See
// scripts/LandingApp.jsx for the same split on the landing page.

import React from 'react';

import { ModalRoot } from './Forms.jsx';
import { DemoVideoModalRoot } from './DemoVideoModalRoot.jsx';
import { CookieConsentRoot } from './CookieConsent.jsx';
import { SiteNav } from './Shell.jsx';
import { Footer } from './Sections.jsx';
import {
  ProductHero,
  ProductAnchorStrip,
  ProductPromiseSection,
  ProblemFixSection,
  ProductModulesSection,
  HowProductWorksSection,
  AgencyUseCasesSection,
  AntiSurveillanceSection,
  ProductFaqSection,
} from './ProductSections.jsx';
import {
  ReportAnatomySection,
  ForensicStorySection,
  InvoiceDefenseSection,
  AIEconomicsSection,
} from './DashboardWidgets.jsx';

function useRevealOnScroll() {
  React.useEffect(() => {
    const els = document.querySelectorAll('.sw-reveal');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

export function ProductApp() {
  useRevealOnScroll();

  return (
    <>
      <SiteNav currentPath="/product" variant="transparent" />
      <ProductHero />
      <ProductAnchorStrip />
      <div className="sw-reveal"><ProductPromiseSection /></div>
      <div className="sw-reveal"><ForensicStorySection /></div>
      <div className="sw-reveal"><ProblemFixSection /></div>
      <div className="sw-reveal"><ReportAnatomySection /></div>
      <div className="sw-reveal"><HowProductWorksSection /></div>
      <div className="sw-reveal"><ProductModulesSection /></div>
      <div className="sw-reveal"><AgencyUseCasesSection /></div>
      <div className="sw-reveal" id="invoice"><InvoiceDefenseSection /></div>
      <div className="sw-reveal"><AntiSurveillanceSection /></div>
      <div className="sw-reveal" id="ai"><AIEconomicsSection /></div>
      <div className="sw-reveal"><ProductFaqSection /></div>
      <Footer />
      <ModalRoot />
      <DemoVideoModalRoot />
      <CookieConsentRoot />
    </>
  );
}
